import styled from 'styled-components'

export const RotaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Avatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-right: 6px;
`

export const RotaBuilderContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(
    100vh - 2 * var(--rota-container-vertical-padding)
  ); // fallback for browsers not supporting dynamic viewport height units
  height: calc(100dvh - 2 * var(--rota-container-vertical-padding));
`
